import * as models from '@app/models/index';
import Injector from '@app/services';
import { IntlService } from '@app/services/intl.service';
import { Grid, ListItem, Typography } from '@material-ui/core';
import * as React from 'react';

const intlService: IntlService = Injector.get(IntlService);

class NoDataComponent extends React.Component<models.INoDataComponentProps, any> {
	constructor(props: models.INoDataComponentProps) {
		super(props);
	}

	public render() {
		return (
			<React.Fragment>
				{!this.props.showTableNoData ? (
					<ListItem>
						<Grid container={true}>
							<Grid item={true} xl={12} lg={12} sm={12} md={12}>
								<Typography align='center'>
									{intlService.GetFormattedMessage('app.shipment.no-data-available')}
								</Typography>
							</Grid>
						</Grid>
					</ListItem>
				) : (
					<tbody>
						<tr className='pt-1'>
							<td colSpan={6}>
								<Typography align='center' variant='subtitle1'>
									{intlService.GetFormattedMessage('app.shipment.no-data-available')}
								</Typography>
							</td>
						</tr>
					</tbody>
				)}
			</React.Fragment>
		);
	}
}
export default NoDataComponent;



// WEBPACK FOOTER //
// ./src/components/shared/no-data.component.tsx